@import '@/theme/media.css';

.region {
  position: fixed;
  z-index: 40;
  top: var(--space-3);
  right: var(--space-3);
  left: var(--space-3);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  pointer-events: none;
}

@media (--not-compact) {
  .region {
    left: auto;
    width: 24rem;
  }
}

.banner {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
  padding: var(--space-2);
  background: var(--surface);
  border: var(--border-width) solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-raised);
  pointer-events: auto;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
  padding: var(--space-2) var(--space-3);
  font: inherit;
  text-align: left;
  text-decoration: none;
  color: var(--text);
  background: none;
  border: 0;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.body:hover {
  background: var(--surface-2);
}

.title {
  font-family: var(--font-heading);
  font-size: var(--text-sm);
  font-weight: var(--weight-bold);
  color: var(--primary-strong);
}

.preview {
  overflow: hidden;
  font-size: var(--text-md);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dismiss {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: var(--tap-min);
  height: var(--tap-min);
  padding: 0;
  color: var(--text-2);
  background: none;
  border: 0;
  border-radius: var(--radius-pill);
}

.offlineRegion {
  position: fixed;
  z-index: 30;
  bottom: calc(5rem + env(safe-area-inset-bottom));
  left: 50%;
  translate: -50% 0;
  pointer-events: none;
}

@media (--not-compact) {
  .offlineRegion {
    bottom: var(--space-5);
  }
}

.offline {
  padding: var(--space-2) var(--space-5);
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
  background: var(--text);
  color: var(--bg);
  border-radius: var(--radius-pill);
  box-shadow: var(--shadow-raised);
}

/* WarningNotice (FR-044) */
.warningMeta {
  margin: 0;
  color: var(--text-2);
  font-size: var(--text-sm);
}

.warningMessage {
  margin: var(--space-4) 0;
  color: var(--text);
  font-size: var(--text-lg);
  font-weight: 600;
  line-height: 1.45;
  white-space: pre-line; /* an administrator's own line breaks are kept */
  overflow-wrap: anywhere;
}

.warningFootnote {
  margin: 0;
  color: var(--text-2);
  font-size: var(--text-sm);
  line-height: 1.45;
}

.warningError {
  margin: var(--space-3) 0 0;
  color: var(--danger-text);
  font-size: var(--text-sm);
  font-weight: 600;
}
